export default __webpack_public_path__ + "static/media/njordanresume.47e4419c.pdf";